module.exports = __webpack_public_path__ + "img/pl.0ca345e7.svg";